import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HandCoins, LogOut, LayoutDashboard, User, Wallet, CalendarClock } from "lucide-react";
import { affiliateApi } from "../../lib/api";

const TABS = [
  { path: "/affiliate/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { path: "/affiliate/payroll", label: "Payroll", icon: CalendarClock },
  { path: "/affiliate/payouts", label: "Payouts", icon: Wallet },
  { path: "/affiliate/profile", label: "Profile", icon: User },
];

export default function AffiliateNav({ affiliateName }) {
  const navigate = useNavigate();
  const location = useLocation();

  const doLogout = async () => {
    try { await affiliateApi.logout(); } catch (_) { /* ignore */ }
    navigate("/affiliate/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-20 border-b border-white/10 bg-[#0A0E17]/90 backdrop-blur" data-testid="affiliate-nav">
      <div className="px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center">
            <HandCoins className="h-5 w-5 text-white" />
          </div>
          <div>
            <div className="text-white font-bold text-[15px] leading-tight">Affiliate Portal</div>
            <div className="text-[10px] text-slate-500 uppercase tracking-widest">{affiliateName}</div>
          </div>
        </div>
        <button
          data-testid="affiliate-logout"
          onClick={doLogout}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-white/10 text-[12.5px] text-slate-300 hover:bg-white/5"
        >
          <LogOut className="h-3.5 w-3.5" /> Sign out
        </button>
      </div>
      <div className="px-6 flex items-center gap-1 border-t border-white/5">
        {TABS.map((t) => {
          const active = location.pathname === t.path;
          const Icon = t.icon;
          return (
            <button
              key={t.path}
              data-testid={`affiliate-nav-${t.label.toLowerCase()}`}
              onClick={() => navigate(t.path)}
              className={`inline-flex items-center gap-1.5 px-3.5 h-11 text-[13px] font-semibold border-b-2 transition-colors ${
                active ? "border-amber-400 text-amber-300" : "border-transparent text-slate-400 hover:text-slate-200"
              }`}
            >
              <Icon className="h-3.5 w-3.5" /> {t.label}
            </button>
          );
        })}
      </div>
    </header>
  );
}
